import { call, put, takeLatest } from "redux-saga/effects";

import {
  ADD_BILLING_ADDRESS_REQUEST,
  ADD_BILLING_ADDRESS_SUCCESS,
  ADD_BILLING_ADDRESS_FAILURE,
  UPDATE_BILLING_ADDRESS_REQUEST,
  FETCH_BILLING_ADDRESS_REQUEST,
  VIEW_BILLING_ADDRESS_REQUEST,
  DELETE_BILLING_ADDRESS_REQUEST,
} from "./BillingAddressTypes";
import axiosInstance from "../instance/AxiosInstance";
import {
  deleteBillingAddressFailure,
  deleteBillingAddressSuccess,
  fetchBillingAddressesFailure,
  fetchBillingAddressesRequest,
  fetchBillingAddressesSuccess,
  updateBillingAddressFailure,
  updateBillingAddressSuccess,
  viewBillingAddressFailure,
  viewBillingAddressSuccess,
} from "./BillingAddressAction";

function* addBillingAddressSaga(action) {
  try {
    const response = yield call(
      axiosInstance.post,
      "http://154.61.173.123:7000/billingaddress/insertaddress",
      action.payload
    );
    yield put({ type: ADD_BILLING_ADDRESS_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: ADD_BILLING_ADDRESS_FAILURE, payload: error.message });
  }
}

const updateBillingAddressApi = (id, payload) =>
  axiosInstance.put(
    `http://154.61.173.123:7000/billingaddress/updateaddress/${id}`,
    payload
  );

function* handleUpdateBillingAddress(action) {
  try {
    const { id, data } = action.payload;
    const response = yield call(updateBillingAddressApi, id, data);
    yield put(updateBillingAddressSuccess(response.data));
  } catch (error) {
    yield put(
      updateBillingAddressFailure(error.response?.data || error.message)
    );
  }
}

function* fetchBillingAddressesSaga(action) {
  try {
    const response = yield call(
      axiosInstance.get,
      `http://154.61.173.123:7000/billingaddress/getaddressbycustomer?customer_id=${action.payload}`
    );
    yield put(fetchBillingAddressesSuccess(response.data.data));
  } catch (error) {
    yield put(fetchBillingAddressesFailure(error.message));
  }
}

function* viewBillingAddressSaga({ payload }) {
  try {
    const response = yield call(
      axiosInstance.get,
      `http://154.61.173.123:7000/billingaddress/getaddress?address_id=${payload}`
    );
    yield put(viewBillingAddressSuccess(response.data));
  } catch (error) {
    yield put(viewBillingAddressFailure(error.message));
  }
}

function* updateBillingAddressSaga({ payload }) {
  try {
    const response = yield call(
      axiosInstance.put,
      `http://154.61.173.123:7000/billingaddress/updateaddress/${payload.id}`,
      payload.data
    );
    yield put(updateBillingAddressSuccess(response.data));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data ||
      error.message ||
      "An error occurred while updating the address.";
    yield put(updateBillingAddressFailure(errorMessage));
  }
}

function* deleteBillingAddressSaga({ payload }) {
  try {
    const response = yield call(
      axiosInstance.delete,
      `http://154.61.173.123:7000/billingaddress/deleteaddress/${payload}`
    );
    yield put(deleteBillingAddressSuccess(payload));
  } catch (error) {
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data ||
      error.message ||
      "An error occurred while deleting the address.";
    yield put(deleteBillingAddressFailure(errorMessage));
  }
}

export default function* billingAddressWatcherSaga() {
  yield takeLatest(VIEW_BILLING_ADDRESS_REQUEST, viewBillingAddressSaga);
  yield takeLatest(ADD_BILLING_ADDRESS_REQUEST, addBillingAddressSaga);
  yield takeLatest(UPDATE_BILLING_ADDRESS_REQUEST, updateBillingAddressSaga);
  yield takeLatest(FETCH_BILLING_ADDRESS_REQUEST, fetchBillingAddressesSaga);
  yield takeLatest(DELETE_BILLING_ADDRESS_REQUEST, deleteBillingAddressSaga);
}
